import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ReviewForm from "@/components/landing/ReviewForm";
import { useLang } from "@/constants/i18n";

export default function ReviewPage() {
    const { t, lang, setLang } = useLang();

    return (
        <div className="grain min-h-screen bg-ivory" data-testid="review-page">
            <header className="mx-auto flex max-w-3xl items-center justify-between px-5 py-6">
                <Link to="/" data-testid="review-home-link" className="flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-t-full border border-gold/60 bg-burgundy font-serif text-lg text-ivory">
                        FP
                    </span>
                    <span className="font-serif text-lg tracking-wide text-ink">FP Legacy Insurance</span>
                </Link>
                <div
                    data-testid="lang-toggle"
                    className="flex items-center rounded-full border border-gold/40 p-0.5"
                >
                    {["es", "en"].map((l) => (
                        <button
                            key={l}
                            data-testid={`lang-toggle-${l}`}
                            onClick={() => setLang(l)}
                            className={`rounded-full px-2.5 py-1 text-[11px] uppercase tracking-widest transition-colors duration-300 ${
                                lang === l ? "bg-burgundy text-ivory" : "text-ink/60 hover:text-burgundy"
                            }`}
                        >
                            {l}
                        </button>
                    ))}
                </div>
            </header>

            <main className="mx-auto max-w-xl px-5 pb-24 pt-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
                    className="border border-gold/30 bg-white p-8 shadow-xl md:p-10"
                >
                    <h1 className="font-serif text-4xl font-light leading-tight text-ink">
                        {t.review.title}
                    </h1>
                    <p className="mt-3 mb-8 text-sm leading-relaxed text-ink/60">{t.review.sub}</p>
                    <ReviewForm showBackLink />
                </motion.div>
            </main>
        </div>
    );
}
